/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const WebhookStepMessages = defineMessages({
  title: {
    id: 'Facebook.WebhookStepMessages.title',
    defaultMessage: 'Configure Facebook webhooks'
  },
  note: {
    id: 'Facebook.WebhookStepMessages.note',
    defaultMessage:
      'The generated request URL will be using the latest service API version. <link>Learn more</link>'
  },
  stepOne: {
    id: 'Facebook.WebhookStepMessages.stepOne',
    defaultMessage:
      'In the Facebook Messenger settings, scroll to the {webhooks}. Click on {configure}.'
  },
  webhooks: {
    id: 'Facebook.WebhookStepMessages.webhooks',
    defaultMessage: 'Configure webhooks'
  },
  configure: {
    id: 'Facebook.WebhookStepMessages.configure',
    defaultMessage: 'Configure'
  },
  stepTwo: {
    id: 'Facebook.WebhookStepMessages.stepTwo',
    defaultMessage:
      'In the {editCallbackURL} window, paste the generated callback URL into the {callbackURL} field.'
  },
  editCallbackURL: {
    id: 'Facebook.WebhookStepMessages.editCallbackURL',
    defaultMessage: 'Edit Callback URL'
  },
  callbackURL: {
    id: 'Facebook.WebhookStepMessages.callbackURL',
    defaultMessage: 'Callback URL'
  },
  stepThree: {
    id: 'Facebook.WebhookStepMessages.stepThree',
    defaultMessage:
      'In the {verifyToken} field, paste the verify token that was generated for you earlier.'
  },
  verifyToken: {
    id: 'Facebook.WebhookStepMessages.verifyToken',
    defaultMessage: 'Verify Token'
  },
  stepFour: {
    id: 'Facebook.WebhookStepMessages.stepFour',
    defaultMessage: 'Click {verifyAndSave}.'
  },
  verifyAndSave: {
    id: 'Facebook.WebhookStepMessages.verifyAndSave',
    defaultMessage: 'Verify and Save'
  },
  stepFive: {
    id: 'Facebook.WebhookStepMessages.stepFive',
    defaultMessage:
      'Click {addSubscriptions}. In the {editPageSubscriptions} window under {subscriptionFields}, select {messages} and {messagingPostbacks}. Click {save}.'
  },
  addSubscriptions: {
    id: 'Facebook.WebhookStepMessages.addSubscriptions',
    defaultMessage: 'Add Subscriptions'
  },
  editPageSubscriptions: {
    id: 'Facebook.WebhookStepMessages.editPageSubscriptions',
    defaultMessage: 'Edit Page Subscriptions'
  },
  subscriptionFields: {
    id: 'Facebook.WebhookStepMessages.subscriptionFields',
    defaultMessage: 'Subscription Fields'
  },
  messages: {
    id: 'Facebook.WebhookStepMessages.messages',
    defaultMessage: 'messages'
  },
  messagingPostbacks: {
    id: 'Facebook.WebhookStepMessages.messagingPostbacks',
    defaultMessage: 'messaging_postbacks'
  },
  save: {
    id: 'Facebook.WebhookStepMessages.save',
    defaultMessage: 'Save'
  },
  generatedCallbackUrlLabel: {
    id: 'Facebook.WebhookStepMessages.generatedCallbackUrlLabel',
    defaultMessage: 'Generated callback URL'
  },
  generateCallbackUrlButtonLabel: {
    id: 'Facebook.WebhookStepMessages.generateCallbackUrlButtonLabel',
    defaultMessage: 'Generate callback URL'
  }
});
